// ////// DEPRICATED ////////
// Messages
export const CREATE_FOLDER_TITLE = 'Opret mappe';
export const CREATE_FOLDER_CANCEL_BUTTON = 'Annuller';
export const CREATE_FOLDER_CREATE_BUTTON = 'Opret';
export const CREATE_FOLDER_INFO = 'Vælg navn til en ny mappe';
export const CREATE_FOLDER_PLACEHOLDER = 'Indtast navn her';
export const EDIT_FOLDER_TITLE = 'Rediger mappe';
export const EDIT_FOLDER_OK_BUTTON = 'Ok';
export const EDIT_FOLDER_CANCEL_BUTTON = 'Annuller';
export const FOLDERS_MOVE_THREADS_NO_FOLDER = 'Du har ingen mapper';
export const EDIT_FOLDER_DELETE_BUTTON = 'Slet mappe';
export const FOLDERS_EDIT_BUTTON = 'Rediger';
export const MESSAGE_NO_THREADS = 'Der er ingen beskedtråde i denne mappe';
export const MESSAGE_SEARCH_NO_THREADS = 'Der er ingen resultater for søgningen';
export const MESSAGE_ADD_BCC_RECIPIENT = 'Tilføj BCC-modtagere';
export const MESSAGE_RECIPIENT_IN_GROUP_COULD_NOT_BE_FOUND = 'kunne ikke tilføjes.';
export const FOLDERS_DELETE_MODAL_TEXT_MOBILE =
  'Hvis du sletter mappen, vil alle beskeder i mappen også blive slettet. \n\nEr du sikker på, at du vil slette mappen?';
export const MESSAGE_TOOLBAR_DELETE_MODAL_NO_MOBILE = 'Annuller';
export const MESSAGE_TOOLBAR_DELETE_MODAL_YES_MOBILE = 'Ok';
export const FOLDERS_DELETE_MODAL_TITLE_MOBILE = 'Slet mappe';
export const MESSAGE_RESPOND_TO_SINGLE_MESSAGE_BTN_TXT = 'Besvar direkte';
export const MESSAGE_THREAD_CREATED_BY = 'Startet af ';
export const MESSAGE_AUTOREPLY_INDICATOR_LABEL = 'Autosvar fra:';
export const MESSAGE_SENSITIVE_INFO_NOT_STEPPED_UP =
  'Beskeden indeholder følsomme personoplysninger. Log ind på et højere sikkerhedsniveau for at læse den.';
export const MESSAGE_THREAD_CREATE_WITH_SENSITIVE =
  'Du har markeret beskeden som følsom og vil ikke kunne åbne den før du har logget in med NemId. Er du sikker på at du vil fortsætte?';

export const MESSAGE_FILTER_MARKED = '*-markerede';
export const MESSAGE_ALERT_SAVE_AS_DRAFT = 'Vil du gemme beskeden som en kladde?';
export const MESSAGE_ALERT_MISSING_RECEIVER = 'Du mangler at angive en modtager';
export const MESSAGE_ALERT_MISSING_TOPIC = 'Du mangler at angive emne';
export const MESSAGE_ALERT_MISSING_MESSAGE = 'Du mangler at skrive en besked';
export const MESSAGE_AUTOREPLY_START = 'STARTER';
export const MESSAGE_AUTOREPLY_END = 'SLUTTER';
export const MOBILE_START_MULTIPLE_THREAD = 'Opret ny besked til den enkelte modtager';

// General error messages
export const MOBILE_ERROR_TEXT_MISSING_OK = 'Ok';
export const MOBILE_ERROR_TEXT_MISSING_TITLE = 'Tekst mangler';
export const MOBILE_ERROR_TEXT_MISSING_MESSAGE = 'Feltet må ikke være tomt';
export const MOBILE_NO_SUPPORTED_MODULES_OK = 'OK';
export const MOBILE_NO_SUPPORTED_MODULES_TITEL = 'ADVARSEL';
export const MOBILE_NO_SUPPORTED_MODULES_MESSAGE = 'Du har ingen moduler der er understøttet i appen.';

// Search
export const MOBILE_SEARCHBAR_REMOVE_KEYBOARD = 'LUK';
export const SEARCH_RECIPIENTS_COULD_NOT_ADD_NEW_RECIPIENTS =
  'Der blev ikke føjet yderligere deltagere til beskedtråden. Tjek evt. internetforbindelsen og prøv igen.';
export const SEARCH_RECIPIENTS_COULD_NOT_FIND_ANY_RECIEVERS =
  'Der kunne ikke findes nogle brugere. Tjek evt. internetforbindelsen og prøv igen.';
export const SEARCH_RECIPIENTS_SEARCH_FAILED = 'Søgning kunne ikke gennemføres';
export const MESSAGE_SENDING = 'Sender...';
export const GENERIC_PLEASE_TRY_AGAIN = 'Prøv venligst igen. Vi beklager fejlen.';
export const MESSAGE_EDIT_RECIPIENTS_BUTTON = 'Rediger modtagere';
export const MESSAGE_EDIT_BCC_RECIPIENT = 'Rediger BCC-modtagere';

export const SEARCH_RECIPIENT_CHILDREN = 'Børn';
export const SEARCH_RECIPIENT_GUARDIAN = 'Forældre';
export const SEARCH_RECIPIENT_EMPLOYEE = 'Medarbejdere';
export const SEARCH_RECIPIENT_GROUP = 'Grupper';

// Drafts
export const MOBILE_LEAVE_NEW_MESSAGE_PAGE_DIALOG_OK_BTN = 'Ja, gem kladde';
export const MOBILE_LEAVE_NEW_MESSAGE_PAGE_DIALOG_TITLE = 'Kladde';
export const MOBILE_LEAVE_NEW_MESSAGE_PAGE_DIALOG_MESSAGE = 'Ønsker du at gemme indholdet på siden som en kladde?';
export const MOBILE_LEAVE_NEW_MESSAGE_PAGE_DIALOG_CANCEL_BTN = 'Nej';
export const MOBILE_WARNING_CANT_MARK_THREAD_OK_BTN = 'Ok';
export const MOBILE_WARNING_CANT_MARK_THREAD_TITLE = 'Kladder';
export const MOBILE_WARNING_CANT_MARK_THREAD_MESSAGE = 'Du kan ikke markere en kladde';
export const MOBILE_WARNING_CANT_MOVE_THREAD_OK_BTN = 'Ok';
export const MOBILE_WARNING_CANT_MOVE_THREAD_TITLE = 'Kladder';
export const MOBILE_WARNING_CANT_MOVE_THREAD_MESSAGE = 'Du kan ikke flytte en kladde';

// Profile bar with institutions and children
export const MOBILE_FILTER_CHILD_OR_INSTITUTION_DIALOG_TITLE = 'Filtrér';
export const PROFILE_EDIT_PROFILE = 'Rediger';
export const PROFILE_LOG_OUT_TEXT = 'Log ud';
export const PROFILE_CONFIRM_LOG_OUT_TEXT = 'Er du sikker på, at du vil logge ud?';
export const PROFILE_CONFIRM_LOG_OUT_TITLE = 'Log ud';
export const PROFILE_MENU_HEADER_SETTINGS = 'INDSTILLINGER';
export const PROFILE_MENU_HEADER_MY_PROFILE = 'MIN PROFIL';
export const PROFILE_MENU_ADDITIONALDATA = 'Stamkort';
export const PROFILE_MENU_CONTACTS = 'Kontakter';
export const PROFILE_MENU_GENERALTERMS = 'Generelle betingelser';
export const PROFILE_MENU_NOTIFICATION_SETTINGS = 'Notifikationsindstillinger';
export const PROFILE_MENU_APP_SETTINGS = 'App indstillinger';

// Groups
export const GROUP_MY_GROUPS_LABEL = 'Mine grupper';
export const GROUP_NO_GROUPS = 'Du er ikke medlem af nogen grupper';
export const GROUPS_CONFIRM_BTN_TRY_AGAIN = 'Prøv igen';
export const GROUPS_GROUP_COULD_NOT_BE_LOADED = 'Gruppen kunne ikke findes';
export const GROUPS_GROUP_COULD_NOT_BE_LOADED_EXPLAINING =
  'Den valgte gruppe kunne ikke hentes. Prøv at hente gruppen igen eller gå tilbage til ';
export const GROUPS_CANCEL_BTN_TEXT = 'Gå tilbage';
export const GROUPS_SET_MEMBERSHIP_FAILED_OK_BTN = 'Ok';
export const GROUPS_SET_MEMBERSHIP_FAILED_TITLE = 'SetMembership() fejlede';
export const GROUPS_SET_MEMBERSHIP_FAILED_DETAILED_TEXT = 'Forespørgslen kunne ikke gennemføres.';
export const MOBILE_GROUPS_TAB_MEMBERSHIPS = 'Medlemmer';

// Global search
export const GLOBAL_SEARCH_OK_BTN_TXT = 'Ok';
export const GLOBAL_SEARCH_SEARCH_FAILED = 'Søgningen kunne ikke gennemføres';
export const GLOBAL_SEARCH_SEARCH_DID_NOT_RETURN_RESULT =
  'Søgningen gav intet resultat. Tjek evt. internetforbindelsen og prøv igen.';
export const GLOBAL_SEARCH_TITLE = 'Søgning';

// Error handling
export const MOBILE_GENERIC_ERROR_TITLE = 'Fejlmeddelelse';
export const MOBILE_GENERIC_ERROR_MESSAGE = 'Der gik noget galt. Prøv igen senere.';
export const MOBILE_UNAUTHORIZED_ERROR_TITLE = 'Fejlmeddelelse';
export const MOBILE_UNAUTHORIZED_ERROR_MESSAGE = 'Du er ikke godkendt til denne handling';
export const MOBILE_STEP_UP_ERROR_TITLE = 'Fejlmeddelelse';
export const MOBILE_STEP_UP_ERROR_MESSAGE = 'Du har ikke adgang til denne handling da du ikke er logget ind med NemId.';
export const CONFIRMBOX_OK_BTN = 'Ok';
export const CONFIRMBOX_FIELDS_MISSING_DATA = 'Felter mangler data';

// Posts
export const NO_POSTS_FILTER = 'Der er ingen opslag for valgte filter';

// Calendar
export const GROUPSEARCH_TITLE = 'Søg i gruppe';
export const CALENDAR_CREATE_EVENT_SUBJECT_TITLE = 'Emne';
export const CALENDAR_CREATE_EVENT_TITLE = 'Titel';
export const CALENDAR_CREATE_EVENT_SUBJECT_PLACEHOLDER = 'Skriv emne';
export const CALENDAR_CREATE_EVENT_TYPE_TITLE = 'Type';
export const CALENDAR_CREATE_EVENT_TYPE_CHOOSE = 'Vælg';
export const CALENDAR_CREATE_EVENT_TO_LABEL = 'Til';
export const CALENDAR_CREATE_EVENT_SEARCH_RECIPIENT_PLACEHOLDER = 'Søg';
export const CALENDAR_CREATE_EVENT_STARTS_LABEL = 'Starter';
export const CALENDAR_CREATE_EVENT_ENDS_LABEL = 'Slutter';
export const CALENDAR_CREATE_EVENT_LOCATION_LABEL = 'Sted';
export const CALENDAR_CREATE_EVENT_EXTRA_LOCATION_PLACEHOLDER = 'Skriv evt. ekstra mødested';
export const CALENDAR_CREATE_EVENT_RESOURCES_PLACEHOLDER = 'Vælg ressourcer';
export const CALENDAR_CREATE_EVENT_DESCRIPTION_PLACEHOLDER = 'Skriv her...';
export const CALENDAR_CREATE_EVENT_ASSOCIATED_INSTITUTION_LABEL = 'Tilknyttet institution';
export const CALENDAR_CREATE_EVENT_TYPE_IS_MISSING_MESSAGE = 'Begivenhedens type mangler at blive udfyldt';
export const CALENDAR_CREATE_EVENT_PARTICIPATORS_MISSING = 'Der er ikke valgt nogen deltagere til begivenheden';
export const CALENDAR_CREATE_EVENT_SUBJECT_MISSING = 'Emnefeltet mangler at blive udfyldt';
export const CALENDAR_CREATE_EVENT_DESCRIPTION_MISSING = 'Der er ikke udfyldt nogen beskrivelse af begivenheden';
export const CALENDAR_CREATE_EVENT_CHOOSE_INSTITUTION = 'Vælg institution';
export const CALENDAR_CREATE_EVENT_REPEAT_TYPE_OCCURENCE_LIMIT_TITLE = 'Slut efter antal gentagelser';
export const CALENDAR_CREATE_EVENT_REPEAT_TYPE_OCCURENCE_NEVER_END_TITLE = 'Begivenhed slutter aldrig';
export const CALENDAR_IMPORTANT_DATES_SHORT_FOR_CLOCK = 'Kl';
export const CALENDAR_OVERLAPPING_EVENTS_INFO_PART1 = 'Ovenstående er begivenheder der overlapper i tidsrummet';
export const CALENDAR_OVERLAPPING_EVENTS_INFO_PART2 = 'til';
export const CALENDAR_OVERLAPPING_EVENTS_LABLE = 'mere';
export const CALENDAR_DELETE_EVENT_WARNING = 'Er du sikker på, at du vil slette begivenheden';
export const CALENDAR_ACCESS_ON_BEHALF_OF_PART1 = 'OBS: Du bruger kalenderen på vegne af';
export const CALENDAR_ACCESS_ON_BEHALF_OF_PART2 = '. Klik her for at komme tilbage til din egen kalender';
export const CALENDAR_WEEK_TXT = 'Uge';
export const CALENDAR_MISSING_RESPOND_TITLE = 'Mangler svar';
export const CALENDAR_OVERVIEW_TODAY_BTN_TEXT = 'I dag';
export const CALENDAR_ALL_DAY_LABEL = 'Heldag';
export const CALENDAR_NO_EVENTS_LABEL = 'Ingen begivenheder';
export const CALENDAR_WARNING_CONLICT_EVENT_SEND_BUTTON = 'Send';
export const MOBILE_CALENDAR_TOOLBAR_ADD_USER_HANDLE_CALENDAR = 'Giv råderet';
export const CALENDAR_ALERT_EVENT_CONFLICTINT_CONFIRM = 'Vil du gemme begivenheden alligevel?';
export const CALENDAR_ADD_SUBJECT = 'Tilføj emne';
export const CALENDAR_LABEL_EVENT_RESOURCES_PLACEHOLDER_EXAMPLE = 'Tilføj ressourcer, fx læringsmaterialer';
export const CALENDAR_LABEL_EVENT_DATEFORMAT = 'dd.mm.åååå';
export const CALENDAR_EVENT = 'Begivenhed';
export const CALENDAR_ALERT_DELETE_EVENT_TEXT = 'Er du sikker på, at du vil slette begivenheden?';
export const CALENDAR_LABEL_EVENT_REPEAT_DAY = 'Gentag efter antal dage';
export const CALENDAR_NO_BIRTHDAY = 'Der er ingen fødselsdage inden for den næste uge';
export const CALENDAR_NO_NOTIFICATION = 'Du har ingen invitationer';
export const CALENDAR_CREATE_MEETING_INTERVAL_TOO_SMALL_WARNING = 'Du har ikke tilføjet nok tid til alle samtalerne';
export const CALENDAR_MEETING_TIME_WARNING = 'Du skal tilføje ';
export const CALENDAR_MEETING_TIME_WARNING_2 = ' for at have nok tid til samtalerne';
export const CALENDAR_MEETING_ALL_DAY_WARNING = 'Du kan ikke vælge dags dato, når det er en heldagsbegivenhed';
// GENERIC CONFIRMBOX TEXTS
export const CONFIRMBOX_SUCCESS = 'Success';

// General input fields
export const INPUT_MAX_ITEMS = 'Max antal er valgt';
export const FREE_TEXT_HEADER = 'Fri tekst';
export const CALENDAR_EVENT_BIRTHDAY_MESSAGE = 'har fødselsdag, tillykke!';

// notification
export const NOTIFICATION_ACTIONBAR_TAB_NAME = 'Invitationer';
export const NOTIFICATION_AND_INVITATION = 'Notifikationer og invitationer';
export const SEE_ALL_BUTTON_TEXT = 'Se alle';
export const NOTIFICATION_INVITATION = 'Invitation:';
export const NOTIFICATION_POSTS = 'Opslaget';
export const NOTIFICATION_BADGE = '99+';
export const NOTIFICATION_POSTS_DELETE = 'er blevet slettet';
export const NOTIFICATION_CALENDAR_RIGHTS_GRANTED = 's kalender';
export const MOBILE_NOTIFICATION_SETTINGS_CONTENT_MENU = 'Det får du notifikationer om';
export const MOBILE_NOTIFICATION_SETTINGS_CONTENT_MESSAGES = 'Beskeder';
export const MOBILE_NOTIFICATION_SETTINGS_CONTENT_CALENDAR = 'Kalender';
export const MOBILE_NOTIFICATION_SETTINGS_CONTENT_CALENDAR_ALL = 'Alle Begivenheder';
export const MOBILE_NOTIFICATION_SETTINGS_PLATFORM_MENU = 'Sådan får du notifikationer';
export const MOBILE_NOTIFICATION_SETTINGS_MOBILE_MENU = 'På mobile enheder';
export const MOBILE_NOTIFICATION_SETTINGS_EMAIL_MENU = 'På email';
export const MOBILE_NOTIFICATION_SETTINGS_EMAIL_ALLOW_LABEL = 'Tillad notifikationer';
export const MOBILE_NOTIFICATION_SETTINGS_EMAIL_EVERY_TIME = 'Hver gang noget sker';
export const MOBILE_NOTIFICATION_SETTINGS_EMAIL_AFTER_TIME_INTERVAL = 'Efter tidsinterval';
export const MOBILE_NOTIFICATION_SETTINGS_ON = 'Til';
export const MOBILE_NOTIFICATION_SETTINGS_OFF = 'Fra';
export const MOBILE_NOTIFICATION_SETTINGS_EDIT = 'Rediger';
export const MOBILE_NOTIFICATION_SETTINGS_CANCEL = 'Annuller';
export const MOBILE_NOTIFICATION_SETTINGS_SAVE = 'Gem';
export const MOBILE_NOTIFICATION_SETTINGS_TITLE_SHORT = 'Notifikationer';
export const MOBILE_NOTIFICATION_SETTINGS_TIME_LABEL = 'Angiv tidspunkt';
export const MOBILE_NOTIFICATION_SETTINGS_EVERY_DAY = 'Hver dag';
export const MOBILE_NO_EMAIL_INFO =
  'Indtast en email adresse under dine kontaktoplysninger for at modtage email push notifikationer.';
export const NOTIFICATION_MEDIA_LABEL = 'Medier';
export const NOTIFICATION_NEW_MEDIA_LABEL = 'Nye medier';
export const CALENDAR_EDIT_LESSON_SUCCESS = 'Dine ændringer er gemt';

// File attachments
export const FILE_ATTACHMENTS_CHOOSE_FROM_PHOTOS = 'Vælg photo fra bibliotek';
export const FILE_ATTACHMENTS_MAX_FILE_SIZE_PART1 = 'Filen må højst være ';
export const FILE_ATTACHMENTS_MAX_FILE_SIZE_PART2 = ' MB';
export const FILE_ATTACHMENTS_EXTENSION_NOT_ALLOWED_PART1 = 'Filtypen ';
export const FILE_ATTACHMENTS_EXTENSION_NOT_ALLOWED_PART2 = ' er ikke tilladt';
export const FILE_MEDIA_ATTACHMENTS_EXTENSION_NOT_ALLOWED =
  'Du kan desværre ikke vedhæfte media filer i mobil appen endnu';

// Profile
export const CONSENT_WARNING_TURN_OFF_ARE_YOU_SURE = 'Er du sikker på, at du vil fortsætte?';
export const CONSENT_WARNING_TITLE = 'ADVARSEL';
export const CONSENT_STEP_UP_WARNING = 'For at redigere dine samtykker skal du logge ind igen med niveau 3';
export const CONSENT_EMPTY_CONSENTS = 'Du skal gennemgå samtykker i onboarding før du kan redigere dem her';
export const CONSENT_EMPTY_CONSENTS_OTHER_PROFILE = 'Vedkommende har ikke besvaret samtykker i onboarding endnu';
export const SUCCESS_TOAST_MEDIA_CREATE = 'Medier blev oprettet';
export const SUCCESS_TOAST_MEDIA_UPDATE = 'Medier blev opdateret';
export const SUCCESS_TOAST_MEDIA_DELETE = 'Mediet blev slettet';
export const CONSENT_NO_CONSENTS_TO_SEE = 'Der er ingen samtykker at se';
export const SUCCESS_TOAST_FILE_DOWNLOADED = 'Filen blev downloadet';
export const SUCCESS_TOAST_FILE_DOWNLOAD_FAILED = 'Der gik noget galt. Filen kunne ikke downloades';
export const CALENDAR_TEACHER_TXT = 'Lærer';
export const CALENDAR_EXTRA_LOCATION_TXT = 'Ekstra lokaler';
export const CALENDAR_CLOCK_ABBREVATION = 'kl.';
export const ADDITIONAL_MASTER_DATA_NO_INFORMATION = 'Der er ingen stamkortoplysninger på';

export const CALENDAR_INFO_DATA_CAN_BE_OVERWRITTEN =
  'Bemærk: Teksten kan blive overskrevet af skemaplanlægningssystemet';
export const CALENDAR_FILE_SHARING_AWARENESS = 'Bemærk: Alle, der er inviteret til samtalen, kan se vedhæftninger';
export const CALENDAR_FILTER_OPTION_MEETINGS = 'Samtaler';
export const CONFIRM_MESSAGE_REMOVED_STYLE =
  'Hvis du ønsker at redigere dette opslag, vil al tekstformattering, fx skrifttype eller farver, blive fjernet.';

export const MEDIA_VIDEO_TYPE_TITLE = 'Video';
export const MEDIA_SOUND_TYPE_TITLE = 'Sound';

export const DATE_PICKER_DATE_INVALID_BODY = 'Du kan ikke vælge en dato i fortiden';
export const SUCCESS_TOAST_RESPOND_CONVERSATION_MEETING = 'Tiden er reserveret';

export const ONBOARDING_LAST_STEP_DONE = 'Færdig';
export const LOGGED_OUT_OF_THE_APP_TITLE = 'Du vil blive logget ud af appen.';
export const LOGIN_AGAIN_IN_BROWSER_TITLE = "Næste gang du åbner app'en, skal du logge ind igen.";
export const EXPORT_MEDIA_TITLE = 'Eksportér';

export const APP_ONBOARDING_MODAL_FACEID_CONTENT = 'Vil du bruge ansigtsgenkendelse til at logge ind i Aula?';
export const APP_ONBOARDING_MODAL_FACEID_DENIED_CONTENT =
  'Din ansigtsgenkendelse blev ikke godkendt.\nVil du prøve igen?';
export const APP_ONBOARDING_MODAL_FACEID_TITLE = 'Ansigtsgenkendelse';

export const MOBILE_APP_ONBOARDING_INTRODUCTION =
  'Første gang du logger ind i Aula, skal du vælge nogle generelle indstillinger, som du fremadrettet skal bruge til at logge ind med.';
export const MOBILE_APP_ONBOARDING_DATA_ACCESS_TITLE = 'Data adgang';
export const MOBILE_APP_ONBOARDING_DATA_ACCESS_DESCRIPTION =
  "For at benytte app'en skal du give den lov til at tilgå data om dig i Aula. Du kan til hver en tid fjerne accepten igen.";
export const MOBILE_APP_ONBOARDING_DATA_ACCESS_SWITCH_TEXT = "Jeg giver app'en lov til at tilgå min data i Aula";
export const MOBILE_APP_ONBOARDING_PINCODE_TITLE = 'Pinkode';
export const MOBILE_APP_ONBOARDING_PINCODE_DESCRIPTION =
  'Vælg en pinkode, som du kan bruge til hurtigt at logge ind med. Pinkoden skal bestå a 4 cifre.';
export const MOBILE_APP_ONBOARDING_NOTIFICATIONS_TITLE = 'Notifikationer';
export const MOBILE_APP_ONBOARDING_NOTIFICATIONS_DESCRIPTION = 'Jeg ønsker notifikationer på:';
export const MOBILE_APP_ONBOARDING_NOTIFICATIONS_MOBILE_SWITCH = 'Mobil';
export const MOBILE_APP_ONBOARDING_NOTIFICATIONS_EMAIL_SWITCH = 'Email';
export const MOBILE_APP_ONBOARDING_ERROR_INVALID_PIN = 'Pinkoden er ugyldig';
export const MOBILE_APP_ONBOARDING_ERROR_DATA_ACCESS_NOT_ACCEPTED =
  'Tilladelse til data adgang skal gives for at kunne benytte appen';
export const MOBILE_APP_ONBOARDING_PINCODE_LABEL = 'Indtast pinkode';
export const MOBILE_APP_ONBOARDING_PINCODE_LABEL_REENTRY = 'Gentag pinkode';
export const MOBILE_PIN_LOGIN_DESCRIPTION = 'Indtast kode for at logge ind i Aula';
export const MOBILE_PIN_LOGIN_FINGERAFTRYK_LINK = 'Login med fingeraftryk';
export const MOBILE_PIN_LOGIN_UNI_TEXT = 'Hvis du har glemt din kode, kan du logge ind med Unilogin.';
export const MOBILE_PIN_LOGIN_UNI_LINK = 'Login med Unilogin';
export const MOBILE_PIN_LOGIN_WRONG_PIN_TITLE = 'Forkert kode';
export const MOBILE_PIN_LOGIN_WRONG_PIN_DESCRIPTION = 'Du har indtastet en forkert kode.';
export const MOBILE_PIN_LOGIN_WRONG_PIN_OK_BTN = 'Prøv igen';
export const MOBILE_APP_ONBOARDING_PIN1_PLACEHOLDER = 'Indtast 4 cifre';
export const MOBILE_APP_ONBOARDING_PIN2_PLACEHOLDER = 'Gentag 4 cifre';
export const MOBILE_MODULES_CHANGED_WARNING =
  'Dine tilgængelige moduler er blevet ændret af en administrator. Det er muligvis nødvendigt at du genstarter appen for at de kan indlæses korekt.';
export const MOBILE_PIN_LOGIN_FACEID_LINK = 'Login med ansigtsgenkendelse';

// gallery

export const GALLERY_ALBUM_SHARED_WITH = 'Delt med';
export const GALLERY_ALBUM_TAG = 'Tag';
export const GALLERY_ALBUM_TAGS = 'Tags';
export const GALLERY_CREATE_ALBUM = 'Opret Album';
export const GALLERY_CREATE_ALBUM_SUCCESS_TOAST = 'Albummet blev oprettet';
export const GALLERY_NEXT = 'Næste';
export const GALLERY_EDIT_TAGS = 'Rediger tags';
export const GALLERY_ALBUM_TITLE = 'Titel';
export const GALLERY_WRITE_HERE = 'Skriv her';
export const GALLERY_ALBUM_DESCRIPTION = 'tilføj evt. beskrivelse';
export const GALLERY_SEARCH_PEOPLE = 'Søg efter personer';
export const GALLERY_SEARCH_GROUP = 'Søg efter gruppe';
export const GALLERY_SAVE = 'Gem';
export const GALLERY_MEDIA_FROM = 'Medier fra';
export const GALLERY_ALBUM_INSTITUTION = 'Tilknyttet institution';
export const GALLERY_ADD_MEDIA = 'Tilføj medier';
export const GALLERY_PICK_ALL = 'Vælg alle';
export const GALLERY_PICK = 'Vælg';
export const GALLERY_MEDIA_CHOSEN = 'medier valgt';
export const GALLERY_TAGGED = 'Opmærket';
export const GALLERY_TAG_THE_FOLLOWING = 'Opmærk følgende billeder';
export const GALLERY_DETAILS_HEADER = 'Detaljer';
export const GALLERY_WARNING_DELETE_MEDIA = 'Er du sikker på, at du vil slette mediet?';
export const GALLERY_ALBUM_TITLE_MISSING = 'Albummets titel er ikke udfyldt';
export const GALLERY_DOWNLOAD_MEDIA_TOAST = 'Gemt i fotos';

// Help
export const HELP_GUIDE_TITLE_LEAVE_CONVERSATION = 'Forlad samtale';
export const HELP_GUIDE_TEXT_TURN_OFF_NOTIFICATIONS =
  'Du kan slå notifikationer fra, hvis du ikke længere ønsker at modtage notifikationer, når der kommer nye beskeder i samtalen.';
export const HELP_GUIDE_TEXT_LEAVE_CONVERSATION =
  'Du kan forlade en samtale, hvis du ikke længere ønsker at modtage nye beskeder, når nogle af deltagerne skriver en ny besked.';
export const HELP_GUIDE_TEXT_MARK_AS_SENSITIVE =
  'Du kan markere en besked som følsom, hvis den indeholder følsomme personoplysninger. Det betyder, at modtagerne skal logge ind på et højeresikkerhedsniveau,for at kunne læse beskederne.';
export const HELP_GUIDE_TEXT_ADD_MESSAGE_TO_SECUREFILE =
  'Du kan tilknytte en hel samtale til en sikker fil, hvis der er behov for dokumentation. Det kan fx være en besked om mistrivsel, der skal tilknyttes et observationsdokument.';

export const HELP_GUIDE_HELP = 'Hjælp';
export const HELP_GUIDE_TITLE = 'Vidste du, at du kan...?';
export const HELP_GUIDE_FILTER = 'Du kan filtrere efter type af begivenhed, hvis du fx kun ønsker at se typen ’Møder’.';
export const HELP_GUIDE_TITLE_FILTER = 'Filtrere';
export const HELP_GUIDE_TITLE_OPEN_CALENDAR = 'Åbne kalender';
export const HELP_GUIDE_TEXT_OPEN_CALENDAR =
  'Du kan åbne en anden bruger eller ressources kalender, hvis du vil se, hvornår brugeren eller ressourcen er ledig.';
export const HELP_GUIDE_GIVE_TITLE_GIVE_PERMISSION = 'Give råderet';
export const HELP_GUIDE_GIVE_TEXT_GIVE_PERMISSION =
  'Du kan give en anden bruger råderet over din kalender. Det betyder, at brugeren kan håndtere din personlige kalender, fx booke møder eller acceptere mødeinvitationer på dine vegne.';
export const HELP_GUIDE_GIVE_TITLE_PERMISSION = 'Kalendere, jeg har råderet over';
export const HELP_GUIDE_GIVE_TEXT_PERMISSION =
  'Hvis en anden bruger har givet dig råderet over deres personlige kalender, kan du klikke på brugeren og se deres kalender samt bruge kalenderen på vegne af vedkommende. Du kan fx booke møder eller acceptere mødeinvitationer på deres vegne.';
export const HELP_GUIDE_CREATE_SAFE_FILE =
  'Når du opretter en sikker fil, skal du vælge én gruppe, som den sikre fil omhandler. Derudover kan du vælge et eller flere børn, som den sikre fil omhandler.';
export const HELP_GUIDE_FILTER_DOCUMENTS =
  'Du kan filtrere dine sikre filer efter grupper eller børn. Du kan kombinere filtreringen og vælge et barn og derefter en gruppe, som det valgte barn er med i. Omvendt kan du også vælge en gruppe og derefter et barn inden for den valgte gruppe.';
export const HELP_GUIDE_TITLE_CREATE_SAFE_FILE = 'Oprette en sikker fil';
export const HELP_GUIDE_TITLE_SORT = 'Sortere';
export const HELP_GUIDE_DOCUMENTS_SORT =
  'Du kan sortere alle dine sikre filer efter titel eller hvornår, de sidst er redigeret. Som udgangspunkt er de sorteret efter, hvornår de sidst er redigeret.';
export const HELP_GUIDE_TITLE_SHARE_WITH = 'Del med';
export const HELP_GUIDE_SHARE_WITH =
  'Du kan dele den sikre fil med en medarbejder eller gruppe. Hvis du vælger en gruppe, hvor der både er medarbejdere, forældre og børn, er det kun medarbejderne i gruppen, der får adgang til den sikre fil.';
export const HELP_GUIDE_SEE_REVIEW_LOG = 'Du kan se hvem og hvornår en sikker fil er blevet redigeret.';
export const HELP_GUIDE_TITLE_SEE_REVIEW_LOG = 'Se revisionshistorik';
export const HELP_GUIDE_COPY_LINK =
  'Du kan vælge at kopiere linket til en specifik sikker fil, hvis du har behov for at sende en kopi af den sikre fil i en besked i stedet for at dele den.';
export const HELP_GUIDE_TITLE_COPY_LINK = 'Kopiere link';
export const HELP_GUIDE_TITLE_MARK = 'Markere til arkiv';
export const HELP_GUIDE_MARK =
  'Du kan markere en sikker fil til arkiv, hvis der er tale om information, der er bevaringspligtigt og på et senere tidspunkt skal overføres til Rigsarkivet.';
export const HELP_GUIDE_MARK_1 = '1. Vedtægter, interne politikker, retningslinjer, reglementer m.v.';
export const HELP_GUIDE_MARK_2 =
  '2. Dagsordener, beslutnings- og forhandlingsreferater, mødereferater fra skolebestyrelse, MEDudvalg, pædagogisk råd, personalemøder osv.';
export const HELP_GUIDE_MARK_3 = '3. Årsberetninger, personaleblade, meddelelsesblade, nyhedsbreve m.v.';
export const HELP_GUIDE_MARK_4 = '4. Fortegnelser over elever, der ikke findes i elevadministrationssystemer';
export const HELP_GUIDE_MARK_5 =
  '5. Materiale, som i særlig grad belyser skolens virksomhed, herunder forsøgs- og udviklingsarbejder samt billedmateriale';
export const HELP_GUIDE_MARK_READ_MORE = 'Læs mere';
export const HELP_GUIDE_MARK_LINK =
  'Vejledning til bevaring og kassation af kommunale digitalt skabte data og dokumenter efter 2007';
export const CLOUD_INTEGRATION = 'OneDrive';
export const GOOGLE_DRIVE = 'Google Drev';
export const DOCUMENTS_TYPES_ONEDRIVE_FILES_LINK = 'Gå til OneDrive';
export const PROFILE_MENU_CONTACTINFORMATION = 'Kontaktoplysninger';
export const GALLERY_BLOCKED_COMMUNICATION_WARNING2 =
  'Du kan ikke tilføje medier da din profil er blokeret fra al kommunikation';

export const MASTER_DATA_WORK_PHONE = 'Arbejdstelefonnummer';
export const MASTER_DATA_HOME_PHONE = 'Hjemmetelefonnummer';
export const MASTER_DATA_MOBILE_PHONE = 'Mobiltelefonnummer';
export const MASTER_DATA_PHONE = 'Telefonnummer';
export const MASTER_DATA_EXTERNAL_EMAIL = 'Extern e-mail';
export const MASTER_DATA_POSTAL_CODE = 'Postnummer';
export const WARNING_MASTER_DATA_MAX_LENGTH_DESCRIPTION = 'Du kan max skrive 600 karakterer';
export const WARNING_ANSWER_INFO_NEEDED = 'Du mangler at udfylde nogle oplysninger';
export const POLICY_SUMMARY_5 =
  '<p>For at få adgang til Aula skal du bekræfte, at du er informeret om Aula’s privatlivspolitik, kommunens datapolitik og Aulas dataetik.</p><p>Endvidere skal du tage stilling til en række konkrete samtykker vedrørende hvordan Aula kan behandle data om dig og dine børn. Du kan til enhver tid ændre de konkrete samtykker du har afgivet.</p>';
export const STEP_DESCRIPTION_POLICY =
  '<p>Personoplysninger er information om dig som person. Almindelige personoplysninger er for eksempel dit navn, din adresse, din mail-adresse, dit telefonnummer mv.</p><p>Aula vil i nogle tilfælde også indsamle og behandle følsomme personoplysninger, som kan være information om helbred eller religion i relation til fx kost og særlige behov. Derfor vil du i Aula også skulle anvende login med ekstra sikkerhed, når du skal have adgang til følsomme personoplysninger.</p>';
export const STEP_DESCRIPTION_ADDITIONAL =
  'Stamkort består af supplerende stamdata og tilladelser, hvilket er personlige oplysninger, som din institution har brug for.\nDu kan til hver en tid redigere dem på din profil.';
export const POLICY_CONTENT_PAGE_PRIVATLIVSPOLITIK =
  '<p>For, at du kan bruge Aula skal du bekræfte, at du er informeret om vores privatlivspolitik, kommunens datapolitik og Aulas dataetik.</p><p> Endvidere skal du havetage stilling til en række konkrete samtykker vedrørende hvordan Aula kan behandle data og dig og dine børn (bl.a. hvordan kontaktoplysninger og foto skal kunne deles med fx andre forældre og brugere af Aula).</p><p>Du kan til enhver tid ændre de konkrete samtykker du har afgivet. I Aula indsamler, behandler og opbevarer dine personoplysninger til bestemte.Formålet med Aula og behandlingen af personoplysninger i Aula er at børn, elever, forældre og pædagogisk personale har en sikker og brugervenlig:</p><p>adgang til informationer fra skoledagen og livet i dagtilbuddet</p><p>fælles kanal til at kommunikere og samarbejde i.</p><p>Dette sker i Aula, som er en digital platform, der er ejet af kommunerne.DataansvarAula behandler personoplysninger for både børn, elever, forældre og medarbejdere, og det ansvar tager vi på os, og vi tager det alvorligt.</p><p>Alle skal kunne føle sig trygge, når de samarbejder og kommunikerer i Aula.Vi har som mål, at alle der anvender Aula, skal føle sig godt informeret og vide, at vi har respekt for deres privatliv. Vi tilstræber derfor at være så transparente som muligt. </p><p>Derfor har vi denne privatlivspolitik, hvor vi fortæller dig, hvordan vi behandler og beskytter dine personoplysninger, samt oplyser dig om dine rettigheder.Kommunen er ansvarlig for data i Aula og i kommunens datapolitik kan du læse om, hvordan vi behandler og anvender dine data i kommunen.</p><p>I Aulas dataetik kan du læse om, begrænsninger i datadeling, og hvordan leverandører til Aula skal arbejde for at beskytte brugernes data og forpligte sig til ikke at udnytte informationer i Aula kommercielt.</p><p>Vi er den dataansvarlige – hvordan kontakter du os?Kommunen er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig. Det kan du læse om i vores datapolitik [Link til tekst] Hvis du har spørgsmål eller vil gøre indsigelse mod Aulas behandling af dine personoplysninger, skal du kontakte kommunens DPO (databeskyttelsesrådgiver).</p><p>Du finder kontaktoplysningerne i datapolitikken.Kommunen er ansvarlig for, hvordan og i hvilket omfang Aula bruges i dagtilbud og skole. Kommunen er ifølge lovgivningen ansvarlig for at sikre, at personoplysninger bliver håndteret efter gældende lovgivning.Behandling af personoplysninger i AulaBehandlingen af personoplysning i Aula sker på grundlag af Databeskyttelsesforordningens regler i artikel 6 (stk. 1, litra e) og artikel 9 (stk. 2, litra b).</p><p> De giver grundlag for behandling i forbindelse med offentlig myndighedsudøvelse og for at overholde den dataansvarliges eller den registreredes arbejds- sundheds- og socialretlige forpligtelser og specifikke rettigheder. Den offentlige myndighedsudøvelse er opgaver som kommunerne er pålagt at udføre på skole-, dagtilbuds- og SFO-området og som er reguleret i Bekendtgørelse af lov om Folkeskole og i Bekendtgørelse af lov om dag-, fritids- og klubtilbud til børn og unge.Behandlingen af personoplysninger og andre data i Aula indebærer, at</p><p>- Aula behandler data om dig og dine eventuelle børn i forbindelse med samarbejde og kommunikation i Aula.</p><p>- Kommunens medarbejdere i dagtilbud og skole har adgang til at se dine og dine eventuelle børns personoplysninger.</p><p>- Aula indhenter personoplysninger gennem UNI</p><p>- Login, der styrer, hvilke brugere, som har adgang til Aula.</p><p>- Aula i anonymiseret form indsamler oplysninger om brugernes anvendelse til brug for generel statistik om, hvordan Aula bliver anvendt på den enkelte institution og i kommunen.</p><p>- Du gennem Aula kan sende beskeder til brugere på andre institutioner, der også anvender Aula.</p><p>- Aula deler relevante data med vores samarbejdspartnere (se nedenfor).</p><p>- Aula får behandlet data hos vores samarbejdspartnere (se nedenfor).I det omfang, at der er tale om behandling af personoplysninger, der ligger udenfor ovenstående, vil der forinden blive indsamlet konkrete samtykker (fx hvis dine og dine eventuelle børns kontaktoplysninger og foto skal kunne deles med andre forældre og brugere af Aula). Indsamling af konkret samtykke kan både ske i Aula eller på anden vis hos kommunen, der er dataansvarlig. Denne behandling vil ske på grundlag af Databeskyttelsesforordningens regler i artikel 6 (stk. 1, litra a) og artikel 9 (stk. 2, litra a).</p><p>Hvilke typer af personoplysninger anvender Aula?Oplysninger indsamlet fra brugeren i AulaI Aula har vi brug for kontaktoplysninger til forældre, medarbejdere, børn og elever. Disse oplysninger bliver indsamlet i Aula. Der vil også være mulighed for at tilføje supplerende oplysninger om børn og elever vedrørende forhold der er væsentlige at kende for institutionen. Det kan fx være følsomme oplysninger om helbred, race/etnicitet og religiøs overbevisning,';
export const MODAL_BASIC_ERROR_TITLE = 'Fejl';
export const APP_ONBOARDING_MODAL_FINGERPRINT_DENIED_CONTENT =
  'Dit fingeraftryk blev ikke godkendt.\nVil du prøve igen?';
export const ONBAORDING_MODAL_YES_BUTTON = 'JA';
export const ONBAORDING_MODAL_NO_BUTTON = 'Nej';
export const APP_ONBOARDING_MODAL_FINGERPRINT = 'Fingeraftryk';
export const APP_ONBOARDING_MODAL_FINGERPRINT_CONTENT = 'Vil du bruge fingeraftryk til at logge ind i Aula?';
export const APP_ONBOARDING_MODAL_CONFIRM_FINGERPRINT = 'Bekræft dit fingeraftryk.';
export const APP_ONBOARDING_MODAL_CANCEL_BTN = 'Annuller';
export const MESSAGE_COPY_MESSAGE_BTN_TXT = 'Kopiér';
export const MOBILE_LOGIN_ERROR_LOGIN_USER_ERROR = 'Der gik noget galt under login. Prøv igen';
export const MOBILE_LOGIN_ERROR_LOGIN_TECHNICAL_ERROR = 'Der gik noget galt under login. Prøv igen senere.';
export const MOBILE_LOGIN_ERROR_LOGIN_FAILED_OK = 'OK';
export const MOBILE_LOGIN_ERROR_LOGIN_FAILED_TITLE = 'Advarsel';
export const MOBILE_LOGIN_STEPUP_SUGGESTED =
  'Du bør logge ind med NemId for at få adgang til mere indhold. Ønsker du at fortsætte?';
export const MOBILE_LOGIN_STEPUP_TITLE = 'Advarsel';
export const MOBILE_LOGIN_STEPUP_OK = 'JA';
export const MOBILE_LOGIN_STEPUP_CANCEL = 'Annuller';
export const MOBILE_LOGIN_STEPUP_REQUIRED = 'Du skal logge ind med NemId for at fortsætte';
export const MOBILE_LOGIN_STEPUP_REQUIRED_ONBOARDING =
  'Du skal logge ind med NemId for at udfylde påkrævet information';
export const MOBILE_LOGIN_STEPUP_REQUIRED_TITLE = 'Advarsel';
export const MOBILE_LOGIN_STEPUP_REQUIRED_OK = 'Login';
export const MOBILE_LOGIN_STEPUP_REQUIRED_CANCEL = 'Annuller';
export const MOBILE_LOGIN_WRONG_PROFILE_ROLE_EMPLOYEE =
  'Du forsøger at logge ind som medarbejder. Hent medarbejder appen for at tilgå din medarbejder profil';
export const MOBILE_LOGIN_WRONG_PROFILE_ROLE_GUARDIAN_CHILD =
  'Du har downloadet Aulas medarbejder app. Den har du ikke adgang til. Vil du hente den rigtige app?';
export const MOBILE_LOGIN_WRONG_PROFILE_ROLE_TITLE = 'Advarsel';
export const MOBILE_LOGIN_WRONG_PROFILE_ROLE_OK = 'Ja';
export const MOBILE_LOGIN_WRONG_PROFILE_ROLE_CANCEL = 'Annuller';
export const MOBILE_LOGIN_CANCEL_ONBOARDING_WARNING =
  'Du kan ikke bruge appen uden at gennemføre disse trin. Ønsker du at logge ud?';
export const MOBILE_LOGIN_CANCEL_ONBOARDING_WARNING_YES = 'Log ud';
export const MOBILE_LOGIN_CANCEL_ONBOARDING_WARNING_NO = 'Annuller';
export const DOCUMENT_UPDATED_BY = 'Opdateret af';
export const OVERVIEW_MENU_LABEL_GALLERY = 'ALBUM';
export const DOCUMENT_OVERVIEW_SEARCH_TEXT_PLACEHOLDER = 'Søg efter grupper eller børn';
export const MOBILE_PICK_DOCUMENT_TITLE = 'Vælg en fil';
export const MOBILE_PICKED_A_DOCUMENT_TITLE = '1 fil valgt';
export const MOBILE_PICKED_DOCUMENTS_TITLE = '{0} filer valgt';
export const MOBILE_REVISION_TITLE = 'Revision';
export const FORCED_UPDATE_TEXT = 'Aula er blevet opdateret. Opdatér venligst appen for at fortsætte.';
export const MOBILE_OPEN_LINK_IN_BROWSER_TEXT = 'Klik her for at åbne i browseren';
export const MOBILE_OPEN_GOGOLE_DRIVE_LINK_TEXT = 'Klik her for at åbne filen i Google Drive';
export const MOBILE_OPEN_ONE_DRIVE_LINK_TEXT = 'Klik her for at åbne filen i OneDrive';
export const MOBILE_OPEN_DOCUMENT_LINK_TEXT = 'Klik her for at åbne filen';
export const MOBILE_OPEN_MEDIA_LINK_TEXT = 'Klik her for at afspille';
export const MOBILE_OPEN_DOCUMENT_NOT_FOUND_TEXT =
  'Der skete en fejl. Filen eksisterer ikke længere eller du har ikke rettigheder til at se det.';
export const MOBILE_OPEN_DOCUMENT_OPEN_LINK_TEXT = 'Åbn link';
export const MOBILE_CONVERSATION_MEETING_AVAILABLE_SINGULAR = 'ledig';
export const MOBILE_CONVERSATION_MEETING_AVAILABLE_PLURAL = 'ledige';
export const MOBILE_GLOBAL_SEARCH_EXTERNAL_SECURE_DOCUMENT_TITLE = 'Sikre importerede filer';
export const MOBILE_GLOBAL_SEARCH_INTERNAL_SECURE_DOCUMENT_TITLE = 'Sikre dokumenter og noter';
export const MOBILE_DOWNLOAD_ALBUM_CONTAINS_AUDIO_WARNING =
  'Lydfiler vil ikke blive downloadet, da enhedens foto app ikke understøtter det';
export const MOBILE_DOWNLOAD_EXTERNALD_COUMENT_WARNING =
  'Du er ved at downloade en fil, der kan indeholde følsomme personoplysninger.';
export const DOCUMENT_LOST_EDIT_WARNING = 'Dine ændringer vil ikke blive gemt. Er du sikker på, du vil forlade siden?';
export const DOCUMENTS_SECURE_DESCRIPTION_TEXT = 'INDHOLD';
export const DOCUMENTS_MISSING_TITLE = 'Du skal angive en titel';
export const DOCUMENTS_MISSING_GROUP = 'Du skal vælge en gruppe';
export const DOCUMENTS_SHARE_WITH_RECIPIENTS_NOT_IN_INSTITUTION = 'Brugeren er fra en anden forvaltningsmyndighed';
export const DOCUMENTS_SECURE_CREATE_TITLE = 'Sikker fil';
export const ATTACHMENT_DOWNLOAD_WARNING = 'Vil du hente denne fil ned på din enhed?';
export const ATTACHMENT_DOWNLOAD_WARNING_TITLE = 'Download';
export const DOCUMENTS_SECURE_SHARE_BUTTON = 'DEL';
export const DOCUMENTS_SHARE_SUCCESSFULLY = 'Filen blev delt';
export const DOCUMENTS_MANY_SHARE_SUCCESSFULLY = 'Filerne blev delt';
